import React from "react";
import { Carousel } from "antd";
import BaseForm from "../form/BaseForm";
import "./Commerce.css";

const IMAGES = [
    { title: "Гибкие форматы с высоким потенциалом", image: "/1.png" },
    { title: "Площади — от 50  до 500 м²", image: "/2.png" },
    { title: "Высота потолков — более 4 м", image: "/3.jpg" },
    { title: "Возможность объединения помещений", image: "/4.png" },
    { title: "Тип отделки — улучшенная черновая", image: "/5.png" },
    { title: "Высокий арендный потенциал", image: "/6.png" },
    { title: "Потенциал роста стоимости актива", image: "/7.png" },
];

const Commerce = () => {
    return (
        <>
            <div id="commerce" className="relative flex justify-start items-end max-md:h-500">
                <img src="/commerce.png" alt="commerce" className="w-full h-full object-cover absolute top-0 left-0" />
                <div className="flex flex-col gap-40 relative z-1 max-w-360 bg-white p-40 rounded-3xl -mb-60 max-md:max-w-full">
                    <img src="/commerce-icon.svg" alt="commerce" className="w-50 h-50 object-cover" />
                    <div className="flex flex-col gap-12">
                        <h4 className="leading-[120%] text-[24px] font-semibold uppercase text-[#F0641E]">Коммерческая инфраструктура нового городского формата</h4>
                        <span className="text-[16px] leading-[120%] text-[#2E2E2E70]">
                            Коммерческие помещения RAMS Saiahat —двухэтажная торговая галерея формата mixed-use внутри жилого комплекса. Комфорт для жителей и стабильный клиентский
                            поток для бизнеса.
                        </span>
                    </div>
                </div>
            </div>
            <div className="my-150 px-40 -mr-40 max-md:px-20 max-md:-mr-20 max-md:mb-40 max-md:mt-120">
                <div className="flex items-center justify-between mb-40">
                    <h3 className="text-[36px] max-md:text-[24px] uppercase leading-[110%] font-semibold text-[#2E2E2E]">Преимущества для вашего бизнеса</h3>
                </div>
                <Carousel draggable dots={false} variableWidth className="-ml-15">
                    {IMAGES.map((item, index) => (
                        <div key={index}>
                            <div className="h-400 w-400 max-md:w-300 mx-15 max-md:mx-10 relative">
                                <img src={item.image} alt={item.title} className="w-full h-full object-cover brightness-50 rounded-2xl absolute top-0 left-0" />
                                <h4 className="text-[24px] uppercase leading-[110%] text-white absolute bottom-30 left-30 right-30 max-md:bottom-16 max-md:left-16 max-md:right-16 max-md:text-16">
                                    {item.title}
                                </h4>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
            <div className="mx-40 max-md:mx-20">
                <BaseForm type="up" title="КОММЕРЧЕСКОЕ ПОМЕЩЕНИЕ В RAMS SAIAHAT" description="Оставьте заявку, чтобы получить выгодные условия" typeOfPremises="commerce" />
            </div>
        </>
    );
};

export default Commerce;
